/* eslint-disable no-lone-blocks */
import React, { useContext, useEffect, useMemo, useState } from 'react'
import R from 'ramda'
import {
  Button,
  DatePicker,
  Divider,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Switch,
} from 'antd'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import moment from 'moment'
import FilterContext, { getGridPropsObj } from '../context/FilterContext'
import numeral from 'numeral'

const GridFilter = ({
  header = testHeaders,
  data = testData,
  setFilterData = fd => fd,
  filterCondition = [],
  setFilterCondition = _ => _,
  andOrPass = AND_PASS,
  setAndOrPass = _ => _,
  operatorMap = defaultOperatorMap,
  filterData = defaultFilterData,
  MAX_CONDITION = 9,
  MAX_HEIGHT = '300px',
}) => {
  const headerMap = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(p => [p.ident, p])
      )(header),
    [header]
  )

  useEffect(
    _ => {
      if (filterCondition.length <= 0) setFilterData(data)
      else {
        const da = filterData(
          data,
          headerMap,
          filterCondition.filter(f => f.enabled),
          andOrPass
        )

        setFilterData(da)
      }
    },
    [andOrPass, data, filterCondition, filterData, headerMap, setFilterData]
  )

  const identList = header.map(s => s.ident)

  const onChange = (index, type, value) => {
    filterCondition[index] = { ...filterCondition[index], [type]: value }
    setFilterCondition([...filterCondition])
  }
  const onReplace = (index, obj) => {
    filterCondition[index] = { ...obj }
    setFilterCondition([...filterCondition])
  }

  const onDelete = index => {
    let na = [...filterCondition]
    na[index] = null
    na = na.filter(f => !!f)
    setFilterCondition(na)
  }
  const [allEnable, setAllEnable] = useState(true)

  return (
    <React.Fragment>
      <div
        style={{
          backgroundColor: 'white',
          // border: '1px solid black',
          margin: 5,
        }}
      >
        <div>
          Filter Type :{' '}
          <Radio.Group
            onChange={e => {
              setAndOrPass(e.target.value)
              setFilterCondition(
                filterCondition.map(m => ({ ...m, andOrPass: e.target.value }))
              )
            }}
            value={andOrPass}
          >
            <Radio value={AND_PASS}>AND</Radio>
            <Radio value={OR_PASS}>OR</Radio>
          </Radio.Group>
          <Button
            onClick={_ =>
              setFilterCondition([
                ...filterCondition,
                { enabled: true, andOrPass: andOrPass },
              ])
            }
            type="primary"
            icon="plus"
            disabled={filterCondition.length >= MAX_CONDITION}
          >
            Add Filter
          </Button>
          <Button
            type="danger"
            onClick={_ => setFilterCondition([])}
            icon="delete"
            style={{ marginLeft: '15px' }}
          >
            Remove all Filters
          </Button>
          <Switch
            onChange={enabled => {
              const all = filterCondition.map(f => ({ ...f, enabled }))
              setAllEnable(enabled)
              setFilterCondition(all)
            }}
            style={{ marginLeft: '15px' }}
            checked={allEnable}
            value={allEnable}
            checkedChildren="All Enable"
            unCheckedChildren="All Disable"
            // style={{ alignSelf: 'center' }}
          />
          {/* <Filler /> */}
          <Button
            style={{ marginLeft: '15px' }}
            icon="info-circle"
            onClick={_ => {
              // Operator info array using your constants
              Modal.info({
                title: `Operator Information`,
                width: 1000,
                height: 500,
                content: (
                  <div style={{ maxHeight: 450, overflow: 'auto' }}>
                    <table
                      style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        border: '1px solid #ccc',
                      }}
                    >
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: 8 }}>
                            Operator
                          </th>
                          <th style={{ border: '1px solid #ccc', padding: 8 }}>
                            Description
                          </th>
                          <th style={{ border: '1px solid #ccc', padding: 8 }}>
                            Type
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {operatorInfo.map(({ op, desc, type }) => (
                          <tr key={op}>
                            <td
                              style={{ border: '1px solid #ccc', padding: 8 }}
                            >
                              {op}
                            </td>
                            <td
                              style={{ border: '1px solid #ccc', padding: 8 }}
                            >
                              {desc}
                            </td>
                            <td
                              style={{ border: '1px solid #ccc', padding: 8 }}
                            >
                              {type}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ),
              })
            }}
          >
            Description
          </Button>
        </div>
        <Divider style={{ marginTop: 10, marginBottom: 5 }} />
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            width: '100%',
            overflow: 'auto',
            maxHeight: MAX_HEIGHT,
          }}
        >
          {filterCondition.map((fill, idx) => (
            <FilerComponent
              andOrPass={andOrPass}
              key={idx}
              index={idx}
              identList={identList}
              headerMap={headerMap}
              onChange={onChange}
              onReplace={onReplace}
              onDelete={onDelete}
              operatorMap={operatorMap}
              MAX_CONDITION={MAX_CONDITION}
              {...fill}
            />
          ))}
        </div>

        {/* <Divider /> */}
        {/* <Input.TextArea value={JSON.stringify(filterCondition)} rows={5} /> */}
      </div>
    </React.Fragment>
  )
}

const FilerComponent = ({
  index,
  ident,
  identList,
  headerMap,
  onChange,
  onReplace,
  operation,
  value,
  value2,
  enabled = true,
  onDelete,
  operatorMap = defaultOperatorMap,
  MAX_CONDITION = 9,
}) => {
  // it take the old value in ident
  const { type, choices, isDateWithTime = false } = headerMap[ident] || {}
  const isContainsRange = useMemo(
    _ => {
      return operation === RANGE
    },
    [operation]
  )

  return (
    <fieldset
      key={index}
      style={{
        display: 'grid',
        gridTemplateColumns:
          (MAX_CONDITION < 10 ? '15px' : '20px') +
          ' 70px 200px 180px ' +
          (isContainsRange ? '350px ' : '150px') +
          ' 50px',
        border: '1px solid #e5dede',
        margin: 5,
        gap: 5,
        padding: 5,
        width: 'auto',
      }}
    >
      {/* <legend style={{ width: '20px' }}>{index + 1}</legend> */}
      <div
        style={{
          borderRight: '1px solid #e5dede',
          alignContent: 'center',
          textAlign: 'center',
        }}
      >
        <b>{index + 1}</b>
      </div>
      <Switch
        onChange={enabled => onChange(index, 'enabled', enabled)}
        checked={enabled}
        value={enabled}
        checkedChildren="Apply"
        unCheckedChildren="Skip"
        style={{ alignSelf: 'center' }}
      />
      <Select
        showSearch
        optionFilterProp="children"
        onChange={value => {
          onReplace(index, {
            type: headerMap[value].type,
            ident: value,
            operation: EQ,
            value:
              headerMap[value].type === COL_DATETIME
                ? moment().format('YYYY-MM-DD')
                : undefined,
            isDateWithTime: isDateWithTime,
            enabled: true,
          })
        }}
        value={ident}
      >
        {identList.map(ident => (
          <Select.Option key={ident}>{headerMap[ident].display}</Select.Option>
        ))}
      </Select>
      <Select
        onChange={value => onChange(index, 'operation', value)}
        value={operation}
      >
        {(operatorMap[type] || []).map(eq => (
          <Select.Option key={eq}>{eq}</Select.Option>
        ))}
      </Select>
      {type === 'str' && !choices && (
        <Input
          onChange={e => onChange(index, 'value', e.target.value)}
          value={value}
          disabled={operation === EMPTY}
        />
      )}

      {type === COL_STR && choices && (
        <Select
          onChange={value => onChange(index, 'value', value)}
          value={value}
        >
          {choices.map(({ value, text }) => (
            <Select.Option key={value}>{text}</Select.Option>
          ))}
        </Select>
      )}
      {type === COL_NUM && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: operation === RANGE ? '1fr 1fr' : '1fr',
          }}
        >
          <InputNumber
            onChange={value => onChange(index, 'value', value)}
            value={value}
            style={{ width: '100%' }}
          />
          {type === COL_NUM && operation === RANGE && (
            <InputNumber
              onChange={value => onChange(index, 'value2', value)}
              value={value2}
              style={{ marginLeft: 5, marginRight: '5px', width: '100%' }}
            />
          )}
        </div>
      )}

      {type === COL_DATETIME && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: operation === RANGE ? 'auto auto' : '1fr',
          }}
        >
          <DatePicker
            style={{ width: '150px', minWidth: '150px' }}
            onChange={value =>
              onChange(
                index,
                'value',
                isDateWithTime
                  ? value.format('YYYY-MM-DDTHH:mm')
                  : value.format('YYYY-MM-DD')
              )
            }
            value={moment(value)}
            showTime={
              isDateWithTime
                ? {
                    format: 'h:mm',
                    defaultValue: moment('00:00', 'HH:mm'),
                  }
                : false
            }
            format={isDateWithTime ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY'}
          />
          {type === COL_DATETIME && operation === RANGE && (
            <DatePicker
              showTime={
                isDateWithTime
                  ? {
                      format: 'h:mm',
                      defaultValue: moment('00:00', 'HH:mm'),
                    }
                  : false
              }
              onChange={value2 =>
                onChange(
                  index,
                  'value2',
                  isDateWithTime
                    ? value2.format('YYYY-MM-DDTHH:mm')
                    : value2.format('YYYY-MM-DD')
                )
              }
              value={moment(value2)}
              format={isDateWithTime ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY'}
              style={{ marginLeft: '5px' }}
            />
          )}
        </div>
      )}

      {type === COL_BOOL && (
        <Select
          onChange={value => onChange(index, 'value', value)}
          value={value}
        >
          <Select.Option key="Y">Y-YES</Select.Option>
          <Select.Option key="N">N-NO</Select.Option>
        </Select>
      )}
      <Button icon="delete" onClick={_ => onDelete(index)} />
    </fieldset>
  )
}

export const defaultFilterData = (
  data,
  headerMap,
  filterList,
  andOr = AND_PASS,
  generateFilterConditionType = defaultGenerateFilterConditionType
) => {
  if (filterList.length <= 0) return data
  const filcond = filterList.map(f => generateFilterConditionType(f, headerMap))
  const finalConditionFilter =
    andOr === AND_PASS ? R.allPass(filcond) : R.anyPass(filcond)

  return data.filter(finalConditionFilter)
}

export const defaultGenerateFilterConditionType = (
  { type, ident, operation, value, value2 },
  headerMap
) => {
  // Skip only when there is no value to compare. Do NOT use `!value`: numeric
  // inputs (e.g. Man Hours) yield 0, which is a valid filter value.
  if (!ident || R.isNil(value) || value === '') return _ => true

  if (operation === EMPTY) return d => R.isNil(d[ident])

  if (headerMap[ident] && headerMap[ident].filterFunction)
    return headerMap[ident].filterFunction({
      type,
      ident,
      operation,
      value,
      value2,
    })

  const header = headerMap[ident] || {}

  const {
    dataFormatter,
    displayFormat,
    dataFormat,
    choices,
    dataGetter,
  } = header

  const extractData = ({ rowData = [] }) => {
    const rawData = rowData[ident]

    if (dataGetter) {
      return dataGetter({ header, rowData })
    }

    if (type === 'date-time') {
      return R.isNil(rawData)
        ? undefined
        : moment.isDate(rawData)
        ? moment(rawData).format(dataFormat)
        : moment.isMoment(rawData)
        ? rawData.format(dataFormat)
        : rawData
    }

    return rawData
  }

  const formatData = ({ value, rowData }) => {
    // if(choices && choices.length > 0)  return value;

    if (dataFormatter) {
      return dataFormatter({ value, rowData, header })
    }

    if (R.isNil(value)) return ''

    if (type === COL_NUM && displayFormat) {
      return isNaN(parseInt(value))
        ? value
        : numeral(value).format(displayFormat)
    }

    if (type === COL_DATETIME && displayFormat) {
      return moment(value, dataFormat).format(displayFormat)
    }

    return value + ''
  }

  const formattedChoices = val => {
    if (!choices || choices.length === 0) return val
    const choice = choices.find(c => c.value === val)
    return choice ? choice.text : val
  }

  const extractAndFormatData = rowData =>
    formatData({ value: extractData({ rowData }), rowData })

  // Raw extracted value (runs dataGetter but skips displayFormat) — used for
  // numeric/date comparisons so parseFloat/getMoment see unformatted values.
  const extractRawData = rowData => extractData({ rowData })

  // Per-row value getters, one per column type.
  const ci = s => (s || '').toUpperCase() // case-insensitive normalize
  const strVal = d => extractAndFormatData(d) || ''
  const numVal = d => parseFloat(extractRawData(d))
  const dateVal = d => getMoment(extractRawData(d))
  const boolVal = d => ci(extractAndFormatData(d)).substr(0, 1)

  // Filter-constant comparison targets (computed once per filter, not per row).
  // Date moments are parsed only for date columns to avoid needless work and
  // moment's fallback-parse warning on non-date values.
  const target = formattedChoices(value)
  const lo = parseFloat(value)
  const hi = parseFloat(value2)
  const valMoment = type === COL_DATETIME ? getMoment(value) : null
  const val2Moment = type === COL_DATETIME ? getMoment(value2) : null

  const predicates = {
    [COL_STR]: {
      [EQ]: d => ci(strVal(d)) === ci(target),
      [EQ_CS]: d => strVal(d) === (target || ''),
      [EQNOT]: d => strVal(d) !== (target || ''),
      [STR_LIKE]: d => ci(strVal(d)).includes(ci(target)),
    },
    [COL_NUM]: {
      [RANGE]: d => numVal(d) >= lo && numVal(d) <= hi,
      [LTH]: d => numVal(d) < lo,
      [LEQ]: d => numVal(d) <= lo,
      [GTH]: d => numVal(d) > lo,
      [GEQ]: d => numVal(d) >= lo,
      [EQ]: d => numVal(d) === lo,
      [EQNOT]: d => numVal(d) !== lo,
    },
    [COL_BOOL]: {
      [EQ]: d => boolVal(d) === value,
      [EQNOT]: d => boolVal(d) !== value,
    },
    [COL_DATETIME]: {
      [EQ]: d => dateVal(d).isSame(valMoment),
      [EQNOT]: d => !dateVal(d).isSame(valMoment),
      [LTH]: d => dateVal(d).isBefore(valMoment),
      [LEQ]: d => dateVal(d).isSameOrBefore(valMoment),
      [GTH]: d => dateVal(d).isAfter(valMoment),
      [GEQ]: d => dateVal(d).isSameOrAfter(valMoment),
      [RANGE]: d =>
        dateVal(d).isBetween(valMoment, val2Moment, undefined, '[]'),
    },
  }

  // Default fallback: case-insensitive equality on the formatted value.
  return (
    (predicates[type] || {})[operation] ||
    (d => ci(extractAndFormatData(d)) === ci(value))
  )
}

const getMoment = strDate => {
  const dt = moment(strDate)
  if (dt.isValid()) return dt.seconds(0)
  else return dt
}

export const GridTable = _ => {
  // const [data, setData] = useState(testData)
  const [filData, setFilterData] = useState([])
  const { setGridProps } = useContext(FilterContext)
  const [filterCondition, setFilterCondition] = useState(testCondition)
  const [andOrPass, setAndOrPass] = useState(AND_PASS)
  useEffect(
    _ => {
      setGridProps(getGridPropsObj(testHeaders, testData, setFilterData))
    },
    [setGridProps, setFilterData]
  )

  return (
    <div style={{ backgroundColor: 'white' }}>
      <GridFilter
        header={testHeaders}
        data={testData}
        setFilterData={setFilterData}
        filterCondition={filterCondition}
        setFilterCondition={setFilterCondition}
        andOrPass={andOrPass}
        setAndOrPass={setAndOrPass}
      />
      <Divider />
      <div style={{ width: 1000, height: 700 }}>
        <Grid
          data={filData || []}
          headers={testHeaders}
          render={virtualizedGridRenderer({})}
        />
      </div>
    </div>
  )
}

export default GridFilter

export const AND_PASS = 'AND'
export const OR_PASS = 'OR'

const EQ = 'Equal'
const EQNOT = 'Not Equal'
const EMPTY = 'Is Empty / Null'

const EQ_CS = 'Equal (case sensitive)'
const STR_LIKE = 'Contains'

const LTH = 'Less Than'
const GTH = 'Greater Than'
const LEQ = 'Less Than or Equal'
const GEQ = 'Greater Than or Equal'

const RANGE = 'Range (Between)'

const COL_STR = 'str'
const COL_NUM = 'num'
const COL_DATETIME = 'date-time'
const COL_BOOL = 'bool'

// key should be same as strCol-type
export const defaultOperatorMap = {
  [COL_STR]: [STR_LIKE, EQ, EQ_CS, EQNOT, EMPTY],
  [COL_NUM]: [EQ, EQNOT, EMPTY, LTH, LEQ, GTH, GEQ, RANGE],
  [COL_DATETIME]: [EQ, EQNOT, EMPTY, LTH, LEQ, GTH, GEQ, RANGE],
  [COL_BOOL]: [EQ, EQNOT, EMPTY],
}

export const operatorInfo = [
  {
    op: EQ,
    desc: 'Equal (case insensitive)',
    type: 'String, Number, Date, Boolean',
  },
  { op: EQ_CS, desc: 'Equal (case sensitive)', type: 'String' },
  {
    op: EQNOT,
    desc: 'Not Equal',
    type: 'String, Number, Date, Boolean',
  },
  {
    op: STR_LIKE,
    desc: 'Contains (case insensitive)',
    type: 'String',
  },
  { op: LTH, desc: 'Less Than', type: 'Number, Date' },
  { op: LEQ, desc: 'Less Than or Equal', type: 'Number, Date' },
  { op: GTH, desc: 'Greater Than', type: 'Number, Date' },
  {
    op: GEQ,
    desc: 'Greater Than or Equal',
    type: 'Number, Date',
  },
  { op: RANGE, desc: 'Range (Between)', type: 'Number, Date' },
  { op: EMPTY, desc: 'Is Empty / Null', type: 'All Types' },
]

const testHeaders = []

const testData = []

export const generateDefaultFilterCondition = (
  ident,
  type,
  operation,
  value,
  value2,
  extra = {}
) => {
  return {
    ident,
    type,
    operation,
    value,
    value2,
    enabled: true,
    ...extra,
  }
}

// generate the Sort Mathod
export const generateSortFunction = headers => {
  const sortList = headers.map(h => {
    const dtype = R.toLower(h.type || h.dataType || '')

    const numConv = v => parseFloat(v)
    const strConv = v => v

    const finalsortvalueconv =
      dtype === 'num' || dtype === 'number' ? numConv : strConv

    const sortType = R.toLower(h.sortOrder || h.order || h.sort || 'asc')
    if (sortType === 'desc')
      return R.descend(R.compose(finalsortvalueconv, R.prop(h.ident || h.id)))
    else return R.ascend(R.compose(finalsortvalueconv, R.prop(h.ident || h.id)))
  })
  return R.sortWith(sortList)
}

const testCondition = [
  generateDefaultFilterCondition('bool', COL_BOOL, EQ, 'Y'),
  generateDefaultFilterCondition('bool', COL_BOOL, EQNOT, 'N'),
  generateDefaultFilterCondition('bool', COL_BOOL, EMPTY, 'Y'),
]
